<template>
    <div class="menu" :class="{'menu--active' : active_here}">
        <ul class="menu__list">
            <!-- <li class="menu__item">
                <a href="#head1" class="menu__link" @click="anchor($event, 'head1')">
                    {{ $t('registry') }}  
                </a>
            </li> -->
            <li class="menu__item">
                <a href="#about" class="menu__link" @click="anchor($event, 'about')">
                    {{ $t('about_forum.title') }}  
                </a>
            </li>
            <li class="menu__item">
                <a href="#registration" class="menu__link" @click="anchor($event, 'registration')">
                    {{ $t('registry') }}
                </a>
            </li>
            <li v-if="false" class="menu__item">
                <a href="#head8" class="menu__link" @click="anchor($event, 'head8')">
                    {{ $t('program') }}
                </a>
            </li>
            <li class="menu__item">
                <a href="#nomination" class="menu__link" @click="anchor($event, 'nomination')">
                    {{ $t('nomination.title') }}
                </a>
            </li>
            <li class="menu__item">
                <a href="#partners" class="menu__link" @click="anchor($event, 'partners')">
                    {{ $t('headers.item1') }}  
                </a>
            </li>
            <li v-if="true" class="menu__item">
                <a href="#speakers" class="menu__link" @click="anchor($event, 'speakers')">
                    {{ $t('headers.item2') }}  
                </a>
            </li>
            <li class="menu__item">
                <a href="#footer" class="menu__link" @click="anchor($event, 'footer')">
                    {{ $t('contacts') }}  
                </a>
            </li>
        </ul>
        <div class="menu__inner" @click="closeMenu">
            <div class="menu__line"></div>
            <div class="menu__line"></div>
        </div>
    </div>
</template>

<script scoped>
    export default {
        name: 'ForumMenu',
        props: {
            active: {
                type: Boolean,
                require: true,
            }
        },
        data() {
            return {
                active_here: false,
            }
        },
        watch: {
            active(value) {
                this.active_here = value;
            }
        },
        methods: {
            closeMenu() {
                this.$emit('closeMenu', false);
                this.active_here = false;
            },
            anchor(event, blockID) {
                event.preventDefault();

                const targetElement = document.getElementById(blockID);

                if (targetElement) {
                    // Прокрутите к элементу с учетом смещения (в данном случае, -100 пикселей)
                    window.scrollTo({
                        top: targetElement.offsetTop - 100,
                        behavior: 'smooth',
                    });
                }
                this.closeMenu();
            },
        }

    }
</script>

<style lang="scss" scoped>
.menu {
    position: fixed;
    width: 100%;
    height: 303px;
    background-color: #000;
    z-index: 2;
    transform: translateY(-100%);
    transition: 300ms ease-in-out;
    top: 0;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    &--active {
        transform: translateY(0);
    }
    &__list {
        color: #fff;
        text-align: center;
        padding-top: 25px;
    }
    &__item {
        margin-bottom: 24px;
    }
    &__inner {
        position: relative;
        width: 40px;
        transform: translate(10px,-19px);
    }
    &__line {
        position: absolute;
        width: 100%;
        height: 4px;
        border-radius: 2px;
        background-color: #ffffff;
        margin-bottom: 6px;
        &:nth-child(1) {
            transform: rotate(45deg);
        }
        &:nth-child(2) {
            transform: rotate(-45deg);
            top: 1px;
        }
    }
}
</style>